const OBFUSCATION_BASE_KEY = 'bobra-cache-obfuscation-v1';

const bytesToBase64 = (bytes) => {
    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
};

const base64ToBytes = (base64) => {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
};

const xorBytes = (dataBytes, keyBytes) => {
    const output = new Uint8Array(dataBytes.length);
    for (let i = 0; i < dataBytes.length; i += 1) {
        output[i] = dataBytes[i] ^ keyBytes[i % keyBytes.length];
    }
    return output;
};

export const obfuscatePayload = (payload, salt = '') => {
    try {
        const text = JSON.stringify(payload);
        const dataBytes = new TextEncoder().encode(text);
        const keyBytes = new TextEncoder().encode(`${OBFUSCATION_BASE_KEY}:${salt}`);
        return bytesToBase64(xorBytes(dataBytes, keyBytes));
    } catch (error) {
        return null;
    }
};

export const deobfuscatePayload = (encoded, salt = '') => {
    try {
        if (typeof encoded !== 'string' || !encoded.length) return null;
        const encodedBytes = base64ToBytes(encoded);
        const keyBytes = new TextEncoder().encode(`${OBFUSCATION_BASE_KEY}:${salt}`);
        const text = new TextDecoder().decode(xorBytes(encodedBytes, keyBytes));
        return JSON.parse(text);
    } catch (error) {
        return null;
    }
};

export const buildObfuscatedKey = (raw) => {
    const encoded = obfuscatePayload(String(raw ?? ''), 'cache-key');
    if (!encoded) return null;
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

// Byte-level variant for large payloads (the compact listings cache): no JSON round trip and no
// base64, so a few MB obfuscate in milliseconds. IndexedDB stores the Uint8Array as is.
export const obfuscateBytes = (bytes, salt = '') => {
    const keyBytes = new TextEncoder().encode(`${OBFUSCATION_BASE_KEY}:${salt}`);
    return xorBytes(bytes, keyBytes);
};

export const deobfuscateBytes = (bytes, salt = '') => obfuscateBytes(bytes, salt);
